import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import {
  Button,
  Collapse,
  Grid,
  Select,
  MenuItem,
  Input,
  TableCell,
  TableRow,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { TextField } from "@material-ui/core";
import PropTypes from "prop-types";

import { _parsePhoneNumber } from "../../../partials/validateNumber";
import { formatDatetime } from "../../../utils/setting";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import EditForm from "./editForm";
import { styles } from "./styles";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import Tooltip from "@material-ui/core/Tooltip";
import TableFormat from "../../../partials/TableFormat";
import FilterList from "../../../partials/filterList";
import {
  CHECKING_STATUS,
  CONFIRM_STATUS,
  CANCEL_STATUS,
  MISSED_STATUS,
  SUCCESS_STATUS,
} from "../../../lib/constant";
import _get from "lodash.get";
const headCells = [
  {
    key: "bookingCode",
    numeric: false,
    disablePadding: false,
    label: "booking_listbooking_tablehead_code",
  },
  {
    key: "customerName",
    numeric: false,
    disablePadding: false,
    label: "booking_listbooking_tablehead_customer",
  },
  {
    key: "customerMobile",
    numeric: false,
    disablePadding: false,
    label: "booking_listbooking_tablehead_mobile",
  },
  {
    key: "quantity",
    numeric: false,
    disablePadding: false,
    label: "booking_listbooking_tablehead_quantity",
  },
  {
    key: "branchName",
    numeric: false,
    disablePadding: false,
    label: "booking_listbooking_tablehead_branch",
  },
  {
    key: "createdAt",
    numeric: false,
    disablePadding: false,
    label: "booking_listbooking_tablehead_created_at",
  },
  {
    key: "time",
    numeric: false,
    disablePadding: false,
    label: "booking_listbooking_tablehead_time",
  },
  {
    key: "status",
    numeric: false,
    disablePadding: false,
    disableOpenCollapes: true,
    label: "booking_listbooking_tablehead_status",
  },
  {
    key: "comming",
    numeric: false,
    disablePadding: false,
    label: "booking_listbooking_tablehead_comming",
  },
  // { key: 'action', numeric: false, disablePadding: false, label: 'action' },
];
const listStatus = [
  {
    value: CHECKING_STATUS,
    label: CHECKING_STATUS,
    color: "rgb(251, 140, 0)",
  },
  {
    value: CONFIRM_STATUS,
    label: CONFIRM_STATUS,
    color: "#2d94b2",
  },
  {
    value: CANCEL_STATUS,
    label: CANCEL_STATUS,
    color: "#d03535",
  },
  {
    value: MISSED_STATUS,
    label: MISSED_STATUS,
    color: "#aea7a7",
  },
  {
    value: SUCCESS_STATUS,
    label: SUCCESS_STATUS,
    color: "#82c14d",
  },
];
class EnhancedTable extends React.Component {
  state = {
    order: "desc",
    orderBy: "createdAt",
    selected: [],
    listBookings: [],
    selectedCancel: {
      item: {},
      status: "",
    },
    collapse: [],
    arrange_date: {
      filter_by: "startTime",
      from: this.props.from || "", // mặc định là từ 1 tháng trước ngày hiện tại
      to: this.props.to || "", // nếu mặc định là '' => api sẽ bỏ qua không kiểm tra thời gian khi get list
    },
    statusBooking: -1,
    onTime: 60 * 60 * 1000,
    openDrawer: false,
    listFilter: {
      status: ""
    }
  };
  componentDidMount = () => {
    this.props.onRef(this);
  };
  showFilter = (event) => {
    this.FilterList.toggleDrawer(true, event);
  };
  checkListFilter = () => {
    let { statusBooking, listFilter } = this.state;
    listFilter["status"] = listStatus.find(item => item.value === statusBooking);
    listFilter["status"] = listFilter["status"] ? listFilter["status"].label : "";
    this.setState({ listFilter })
  }
  getListBooking = async (payload, applyFilter = true) => {
    this.handleOpenCollapes(-1);
    let { t } = this.props;
    this.loading.startLoading();
    let { statusBooking, arrange_date, search } = this.state;
    let check;
    let query = {};
    if (arrange_date.from && arrange_date.to)
      query["createdAt"] = { $lte: arrange_date.to, $gte: arrange_date.from };
    if (statusBooking !== -1) query["status"] = statusBooking;
    if (_get(payload, "branchCode", false)) {
      query["branchCode"] = payload.branchCode;
      delete payload.branchCode;
    }

    check = await this.props.bookingDispatch.getListBookings({
      query,
      search: search,
      ...payload,
    });
    this.loading.stopLoading();
    this.checkListFilter();
    if (check.code !== 1) {
      if (check.code === 0 && check.error === 1174)
        this.mSnackbar.handleClick(
          t(
            "you_can_not_view_the_list_of_this_branch_because_you_do_not_have_permission_to_manage_this_branch",
            "error"
          ),
          "error"
        );
      else this.mSnackbar.handleClick(check.message, "error");
    }
    this.props.bookingDispatch.totalBookingChecking(query);
  };
  handleChangeStatus = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({ [name]: value });
  };
  handleChangeBranch = async (value) => {
    this.props.bookingDispatch.changeSelectedBranch(value);
    this.getListBooking(value ? { branchCode: value } : {});
  };
  handleChangeDate = (from, to) => {
    const { arrange_date } = this.state;
    arrange_date.from = from ? new Date(from).setHours(0, 0, 0, 0) : null;
    arrange_date.to = to ? new Date(to).setHours(23, 59, 59, 999) : null;
    this.setState({ arrange_date: arrange_date }, function () {
      this.getListBooking();
    });
  };
  handleUpdateStatus = (booking, status) => {
    booking.status = status;
    this.handleSubmit(booking);
  };
  handleSubmit = async (booking) => {
    let { t } = this.props;
    this.loading.startLoading();
    let check = await this.props.bookingDispatch.editBookingForSpa(booking);
    this.loading.stopLoading();
    if (check.code) {
      this.getListBooking();
      this.mSnackbar.handleClick(t("booking_listbooking_successfully"));
    } else {
      this.mSnackbar.handleClick(
        t("booking_listbooking_unsuccessfully" + " " + check.message),
        "error"
      );
    }
  };
  handleOpenCollapes = (id) => {
    const listBookings = this.props.listBookings;
    const collapse = this.state.collapse;
    for (let i = 0; i <= listBookings.length; i++) {
      if (i === id) {
        collapse[i] = !collapse[i];
      } else collapse[i] = false;
    }
    this.setState(collapse);
  };
  clearFilter = () => {
    let _this = this;
    this.setState(
      {
        statusBooking: -1,
        arrange_date: {},
        listFilter: {
          status: ""
        }
      },
      function () {
        let { page, rowsPerPage } = this.mTable.state;
        let { arrange_date, search, statusBooking } = _this.state;
        let query = {};
        let filter_exact = [];
        if (arrange_date.from && arrange_date.to)
          filter_exact.push({ arrange_date: arrange_date });
        if (statusBooking != -1) filter_exact.push({ status: statusBooking });
        _this.getListBooking({
          page: page,
          limit: rowsPerPage,
          filter_exact: filter_exact,
          search: search,
        });
      }
    );
  };
  renderStatus = (row) => {
    const { classes, t, moduleRole } = this.props;
    return (
      <Select
        value={row.status}
        onChange={(e) => {
          this.handleUpdateStatus(row, e.target.value);
        }}
        name="status"
        input={
          <Input
            name="status"
            disableUnderline={true}
            // fullWidth
            style={{
              color:
                row.status === "cancel"
                  ? "#ff513f"
                  : row.status === "confirm"
                    ? "#1e6bcc"
                    : "",
              fontWeight: "500",
            }}
          />
        }
        displayEmpty
        classes={{
          selectMenu: classes.selectedMenu,
          root: classes.selectedRoot,
        }}
        MenuProps={{
          transitionDuration: 10,
        }}
      >
        {listStatus.map((item, index) => (
          <MenuItem key={index} value={item.value}>
            <Button
              classes={{
                root: classes.btnStatus,
              }}
              size="small"
              style={{ backgroundColor: item.color, color: "#fff" }}
            >
              {t(item.label)}
            </Button>
          </MenuItem>
        ))}
      </Select>
    );
  };
  renderCollapse = (row, index) => {
    const { classes, t, listBookings, total } = this.props;
    const { collapse = [] } = this.state;
    return (
      <TableRow key={index}>
        <TableCell
          colSpan={headCells.length + 1}
          padding={"none"}
          className={classes.tableCellInCollapes}
        >
          <Collapse in={collapse[index]} unmountOnExit>
            <EditForm
              item={index}
              booking={listBookings[index]}
              handleSubmit={this.handleSubmit}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  onDelete = async (selected = []) => {
    let result = await this.props.deleteBooking({ idArr: selected });
    if (result.code === 0) {
      this.mSnackbar.handleClick(result.error, "error");
      return false;
    }
    this.getListBooking();
    return true;
  };
  render() {
    const {
      classes,
      t,
      total,
      count,
      listBookings,
      totalBookingChecking,
      moduleRole,
    } = this.props;
    const { statusBooking, onTime, collapse, listFilter } = this.state;
    const infoServiceBranch = this.props.infoServiceBranch;
    return (
      <React.Fragment>
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <FilterList
          onRef={(id) => (this.FilterList = id)}
          clearFilter={this.clearFilter}
          getList={this.getListBooking}
        >
          <Grid item xs={12} sm={12}>
            <TextField
              select
              label={t("booking_listbooking_status_booking")}
              placeholder={t("pls_select")}
              fullWidth
              className={classes.textField}
              value={statusBooking}
              onChange={this.handleChangeStatus}
              name="statusBooking"
              SelectProps={{
                MenuProps: {
                  className: classes.menu,
                },
              }}
              margin="normal"
              variant="outlined"
            >
              <MenuItem value={-1}>
                {t("booking_listbooking_show_all")}
              </MenuItem>
              {listStatus.map((item, index) => {
                return (
                  <MenuItem
                    key={`status-item-${index}`}
                    value={item.value}
                  >
                    {t(item.label)}
                  </MenuItem>
                )
              })}
            </TextField>
          </Grid>
        </FilterList>
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          orderBy=""
          infoServiceBranch={infoServiceBranch}
          title={
            <React.Fragment>
              {`${t("all")} ${statusBooking == -1 ? "" : `${t(statusBooking).toLowerCase()} `
                }${t("booking")}`}
              {infoServiceBranch && infoServiceBranch.branchName
                ? `${t("of")} ${infoServiceBranch.branchName}`
                : ""}
              <span className={classes.bookingcheking}>
                {totalBookingChecking
                  ? `(${totalBookingChecking} ${t("booking_bookings_cheking")})`
                  : ""}
                {/* ({listBookings.length} {t("booking_bookings_cheking")}) */}
              </span>
            </React.Fragment>
          }
          showFilter={true}
          onDelete={this.onDelete}
          openFilter={(e) => this.showFilter(e)}
          listFilter={listFilter}
          showActionToolbar={true}
          titleActionToolbar={t("booking_listbooking_add_booking")}
          actionToolbar={this.props.addNewBooking}
          placeholder={t("booking_search")}
          headCells={headCells}
          totalCount={total}
          count={count}
          size={"medium"}
          collapse={collapse}
          isCollapse={true}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          getList={this.getListBooking}
          showCheckBox={
            moduleRole &&
              moduleRole.adminBooking &&
              moduleRole.adminBooking.delete === 1
              ? true
              : false
          }
          contentDialog={t("booking_do_you_want_to_delete_selected_booking")}
          // actionColumn={this.actionColumn}
          showFilterBranch={true}
          handleChangeBranch={this.handleChangeBranch}
          rows={listBookings.map((row, index) => {
            let validPhone = _parsePhoneNumber(
              row.countryCode,
              row.customerMobile
            ).format_internal;
            let checkNotification =
              row.startTime - new Date().getTime() <= onTime &&
                row.startTime - new Date().getTime() >= 0 &&
                row.status === "confirm"
                ? true
                : false;
            return {
              id: row._id,
              bookingCode: row.bookingCode,
              customerName: row.customerName,
              customerMobile: validPhone,
              quantity: row.quantity,
              branchName: row.branchName,
              createdAt: formatDatetime(row.createdAt),
              time: formatDatetime(row.startTime),
              status: this.renderStatus(row),
              comming: checkNotification ? (
                <Tooltip
                  title={t(
                    "booking_listbooking_customer_comming_within_an_hour"
                  )}
                >
                  <NotificationsActiveIcon
                    className={classes.notificationsActiveIcon}
                  />
                </Tooltip>
              ) : (
                ""
              ),
            };
          })}
        />
      </React.Fragment>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  total: state.booking.total,
  count: state.booking.count,
  listBookings: state.booking.listBookings,
  infoServiceBranch: state.serviceBranch.infoServiceBranch,
  totalBookingChecking: state.booking.totalBookingChecking,
  selectedBranch: state.booking.selectedBranch,
  listBranch: state.serviceBranch.listBranch,
  moduleRole: state.user.module,
});

const mapDispatch = (dispatch) => ({
  bookingDispatch: dispatch.booking,
  deleteBooking: dispatch.booking.deleteBooking,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(EnhancedTable)));
